import { useState } from "react";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import LegalModal from "@/components/LegalModal";

export default function Footer({ config }) {
  const { t } = useLang();
  const [legal, setLegal] = useState(null);
  const c = config || {};

  return (
    <footer className="bg-ink text-white/90" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-baseline gap-1.5">
              <span className="font-serif font-semibold text-2xl tracking-tight">Hollanda</span>
              <span className="font-serif text-2xl tracking-tight text-brand">Emlak</span>
            </div>
            <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-xs">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/40 font-semibold">{t.footer.contact}</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a href={`tel:${(c.phone || "").replace(/\s/g, "")}`} className="flex items-center gap-2.5 text-white/80 hover:text-white transition-colors" data-testid="footer-phone">
                  <Phone size={16} /> {c.phone || "+31 6 34 97 31 16"}
                </a>
              </li>
              <li>
                <a href={`mailto:${c.email || "info@hollandaemlak.com"}`} className="flex items-center gap-2.5 text-white/80 hover:text-white transition-colors" data-testid="footer-email">
                  <Mail size={16} /> {c.email || "info@hollandaemlak.com"}
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-white/80">
                <MapPin size={16} /> {c.address || "Sierenborch 4, 1043 BA Amsterdam"}
              </li>
              <li>
                <a href={c.instagram || "https://instagram.com/hollandaemlak"} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-white/80 hover:text-white transition-colors" data-testid="footer-instagram">
                  <Instagram size={16} /> @hollandaemlak
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/40 font-semibold">{t.footer.links}</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><button onClick={() => setLegal("privacy")} className="text-white/80 hover:text-white transition-colors" data-testid="footer-privacy">{t.footer.privacy}</button></li>
              <li><button onClick={() => setLegal("terms")} className="text-white/80 hover:text-white transition-colors" data-testid="footer-terms">{t.footer.terms}</button></li>
              <li className="text-white/50">{t.footer.kvk}: {c.kvk || "—"}</li>
              <li className="text-white/50">{t.footer.btw}: {c.btw || "—"}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Hollanda Emlak. {t.footer.rights}</span>
        </div>
      </div>

      <LegalModal type={legal} onClose={() => setLegal(null)} />
    </footer>
  );
}
